var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f28b32;}.b{fill:none;stroke:#003c71;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.c{fill:#003c71;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-975 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(975 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(699.499 529.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.384,53.271c-3.382-3.39-8.347-5.914-18.644-5.914s-16.13,2.957-18.645,5.914"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 3.799,
    cy: 4.983,
    rx: 3.799,
    ry: 4.983,
    transform: "translate(302.447 26.849)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 3.799,
    cy: 4.983,
    rx: 3.799,
    ry: 4.983,
    transform: "translate(325.434 26.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M310.383,21.947c-1.857-.863-4.06-1.091-7.507.653s-4.766,3.982-4.975,5.659"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M339.175,29.068c-.225-2.036-1.172-4.038-4.449-6.082s-5.877-2.011-7.419-1.32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/level6.a609b28467498b1cf3826c70049ca2da.svg";
export { ForwardRef as ReactComponent };